:host {
  --jump-badge-background: var(--primary-standard);
  --badge-color: var(--jump-badge-color, var(--neutral-white));
  --jump-badge-border-radius: 50px;
  --jump-badge-border: var(--primary-standard);
  --jump-badge-padding: 4px 12px;

  display: flex;
  width: fit-content;
  gap: 0.5rem;
  color: var(--badge-color);
  background-color: var(--jump-badge-background);
  align-items: center;
  justify-content: center;
  font-family: var(--ff-primary, 'Arial'), sans-serif;
  font-size: var(--fs-500);
  font-weight: var(--fw-900);
  line-height: 1.2;
  border-radius: var(--jump-badge-border-radius);
  border: solid 1px var(--jump-badge-border);
  white-space: nowrap;
  padding: var(--jump-badge-padding);
  user-select: none;
  cursor: inherit;
}

:host([variant='primary']) {
  &:host([soft]) {
    --jump-badge-background: var(--primary-soft);
    --badge-color: var(--primary-standard);
    --jump-badge-border: var(--primary-soft);
  }
}

:host([variant='secondary']) {
  --jump-badge-background: var(--secondary-standard);
  --jump-badge-border: var(--secondary-standard);

  &:host([soft]) {
    --jump-badge-background: var(--secondary-soft);
    --badge-color: var(--secondary-standard);
    --jump-badge-border: var(--secondary-soft);
  }
}

:host([variant='neutral']) {
  --jump-badge-background: var(--neutral-grey-secondary);
  --jump-badge-border: var(--neutral-grey-secondary);

  &:host([soft]) {
    --jump-badge-background: var(--neutral-grey-disabled);
    --badge-color: var(--neutral-grey-secondary);
    --jump-badge-border: var(--neutral-grey-disabled);
  }
}

:host([variant='danger']) {
  --jump-badge-background: var(--status-danger-standard);
  --jump-badge-border: var(--status-danger-standard);

  &:host([soft]) {
    --jump-badge-background: var(--status-danger-soft);
    --badge-color: var(--status-danger-standard);
    --jump-badge-border: var(--status-danger-soft);
  }
}

:host([variant='success']) {
  --jump-badge-background: var(--status-success-standard);
  --jump-badge-border: var(--status-success-standard);

  &:host([soft]) {
    --jump-badge-background: var(--status-success-soft);
    --badge-color: var(--status-success-standard);
    --jump-badge-border: var(--status-success-soft);
  }
}

:host([variant='warning']) {
  --jump-badge-background: var(--status-warning-standard);
  --jump-badge-border: var(--status-warning-standard);

  &:host([soft]) {
    --jump-badge-background: var(--status-warning-soft);
    --badge-color: var(--status-warning-standard);
    --jump-badge-border: var(--status-warning-soft);
  }
}

:host([dimension='small']) {
  font-size: var(--fs-300);
}

:host([dimension='dot']) {
  font-size: var(--fs-300);
  --jump-badge-padding: 0 5px;
  --jump-badge-border-radius: 50%;
}

:host([dimension='microdot']) {
  width: 0.5rem;
  height: 0.5rem;
  padding: 0;
  --jump-badge-border-radius: 50%;
}

:host([outline]) {
  background-color: var(--jump-badge-background-outline);
  border: 1px solid var(--jump-badge-background);
  color: var(--jump-badge-background);
  background-color: transparent;
}
